import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { ItemPickerComponent } from '../item-picker/item-picker.component';
import { Meta, Title } from '@angular/platform-browser';
import { GMailService } from 'src/app/_services';
import { PersistedProfile, ProfileService } from 'src/app/_services/profiles.service';
import { Money } from '@dintero/money';
import { SidenavService } from 'src/app/_services/sidenav.service';
import { Router } from '@angular/router';

@Component({
  selector: 'items-to-sell-page',
  templateUrl: './items-to-sell-page.component.html',
  styleUrls: ['./items-to-sell-page.component.scss']
})
export class ItemsToSellPageComponent extends MaterialPage implements OnInit {

  @ViewChild('itemPicker') itemPicker?: ItemPickerComponent;
  integrationId?: string | null;
  
  profile: PersistedProfile | undefined;
  updatingProfile: boolean = false;
  
  constructor(
    breakpointObserver: BreakpointObserver,
    private gmailService: GMailService,
    private profileService: ProfileService,
    titleService: Title,
    sidenavService: SidenavService,
    router: Router,
    meta: Meta) {
      
    super(breakpointObserver, titleService, meta, sidenavService, router, $localize `:page title:My items`, '', true);
  }
  
  async ngOnInit() {
    const [integrationId, profiles] = await Promise.all([this.gmailService.getIntegration(), this.profileService.list()]);
    this.profile = profiles[0];
    this.integrationId = integrationId;
  }

  reload() {
    if (this.itemPicker) {
      this.itemPicker.reload();
    }
  }
  
  async onItemListRefreshed() {
  }
  
  async onNewIntegrationScanCompleted() {
    this.integrationId = await this.gmailService.getIntegration();
    this.reload();
  }
  
  async toggleShowNonListedItems() {
    
    this.updatingProfile = true;
    this.profile!.exposeNonListedItems = !this.profile!.exposeNonListedItems;
    
    try {
      this.profile = await this.profileService.update(this.profile!);  
    } finally {
      this.updatingProfile = false;      
    }
  }
  
  get totalPrice(): Money | undefined {
    
    if (!this.itemPicker || this.itemPicker.loading) {
      return undefined;
    }
    
    return this.itemPicker?.items.filter(item => item.priceEUR != undefined).map(item => item.priceEUR)
      .reduce((total, current) => total!.add(current!), Money.of(0, "EUR", { decimals: 0 }))!;
  }
}
